import React from "react";

import AuthContext from "./AuthUserContext";

export const withAuthUser = Component => props => (
  <AuthContext.Consumer>
    {context => <Component {...props} authUser={context} />}
  </AuthContext.Consumer>
);
